import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import { Bounce, Fade } from "react-awesome-reveal";

import { socialLinks } from "../data/socialLinks";

export default function Home() {
  return (
    <div className="flex flex-col bg-gradient-to-br from-dark-bg-950 via-dark-bg-900 to-dark-bg-950 dark:bg-hero-pattern px-3 py-8 h-screen overflow-hidden transition-all duration-300">
      <div className="flex justify-center items-start w-full min-h-screen pt-16 pb-20">
        <div className="relative flex flex-col justify-center items-center gap-3 md:gap-4 max-w-[700px] text-center avatar">
          <Fade delay={1000} triggerOnce={true}>
            <div className="p-2 min-h-[200px] center">
              <div className="ring"></div>
              <div className="relative p-2">
                <img src="imgs/rusty.png" className="rounded-full w-[200px]" />
              </div>
            </div>
          </Fade>
          <Fade delay={1200} triggerOnce={true}>
            <h1 className="font-black text-white text-[32px] md:text-[44px] lg:text-[56px] font-inter tracking-tight leading-tight">
              <span className="bg-gradient-to-r from-accent-400 via-purple-accent-400 to-accent-500 bg-clip-text text-transparent">
                Welcome to My Portfolio
              </span>
            </h1>
          </Fade>
          <Fade delay={1400} triggerOnce={true}>
            <div className="max-w-2xl mx-auto">
              <p className="text-gray-200 md:text-base text-sm leading-relaxed font-inter font-medium">
                <span className="text-xl">👋</span> Hi! Just call me <span className="text-accent-400 font-bold">Rusty</span>. 
                I'm a <span className="text-purple-accent-400 font-bold">Full Stack & Blockchain Developer</span> that thrives on bringing ideas to life with code!
              </p>
              <br />
              <p className="text-gray-200 md:text-base text-sm leading-relaxed font-inter font-medium">
                I advocate for <span className="text-accent-400 font-bold">creative coding</span>, giving you the confidence to build anything imaginable.
                I enjoy speaking about this and sharing knowledge with the community.
              </p>
              <br />
              <p className="text-gray-200 md:text-base text-sm leading-relaxed font-inter font-medium">
                The possibilities are endless in the world of technology.
                So I specialize as a  <span className="text-purple-accent-400 font-bold">Business Developer</span> and <span className="text-purple-accent-400 font-bold">Blockchain Developer.</span>
              </p>
              <br />
              <p className="text-gray-200 md:text-base text-sm leading-relaxed font-inter font-medium">
                Reach out and say <span className="text-accent-400 font-bold">"Hi, Rusty!"</span>. I look forward to hearing from you!
              </p>
            </div>
          </Fade>
          <Bounce delay={1600} triggerOnce={true}>
            <button
              className="group relative px-6 py-3 bg-gradient-to-r from-accent-600 to-purple-accent-600 hover:from-accent-500 hover:to-purple-accent-500 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-glow-purple uppercase tracking-wide text-sm"
              onClick={() => window.open(socialLinks.telegram, '_blank')}
            >
              <span className="relative z-10">Contact Me</span>
              <div className="absolute inset-0 bg-gradient-to-r from-accent-500 to-purple-accent-500 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
          </Bounce>
        </div>
      </div>
    </div>
  );
}
